var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"save-state-indicator-container",class:{ unsaved: !_vm.saved, saved: _vm.saved }},[(_vm.saved)?_c('span',[_vm._v("Saved")]):_c('span',[_vm._v("Unsaved")])])}
var staticRenderFns = []

export { render, staticRenderFns }